import React from 'react';
import { Panel } from 'src/modules/shared/components/molecules/panel';
import {
  SectionSidebarMenu,
  type SectionSidebarMenuItem,
} from 'src/modules/shared/components/molecules/section-menu';
import { ExpandableSection } from 'src/modules/shared/components/molecules/expandable-section';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

export type ReportsTabKey = 'basic' | 'advanced';

interface ReportsSidebarProps {
  activeTab: ReportsTabKey;
  items: SectionSidebarMenuItem[];
  onSelect: (value: ReportsTabKey) => void;
}

const ReportsSidebarContent: React.FC<ReportsSidebarProps> = ({
  activeTab,
  items,
  onSelect,
}) => (
  <SectionSidebarMenu
    items={items}
    activeId={activeTab}
    onSelect={(value) => onSelect(value as ReportsTabKey)}
    variant="neutral"
    appearance="filled"
  />
);

export const ReportsSidebar: React.FC<ReportsSidebarProps> = ({
  activeTab,
  items,
  onSelect,
}) => {
  const { t } = useI18n();

  return (
    <>
      <div className="hidden w-72 flex-shrink-0 border-r lg:block">
        <Panel variant="neutral" appearance="ghost" className="p-3">
          <ReportsSidebarContent
            activeTab={activeTab}
            items={items}
            onSelect={onSelect}
          />
        </Panel>
      </div>

      <div className="m-4 rounded-lg border border-neutral-200 bg-white lg:hidden">
        <ExpandableSection
          title={t('reports.calls.views')}
          isInitiallyExpanded={false}
          expansionControl="left-icon"
          contentClassName="max-h-80 overflow-y-auto"
          showScrollHint
        >
          <ReportsSidebarContent
            activeTab={activeTab}
            items={items}
            onSelect={onSelect}
          />
        </ExpandableSection>
      </div>
    </>
  );
};
